import { ArrowRight } from "@phosphor-icons/react";
import { Reveal } from "./Reveal";

export default function CTASection() {
  return (
    <section className="mx-auto max-w-7xl px-5 pb-24 sm:px-8 lg:pb-32" data-testid="cta-section">
      <Reveal>
        <div className="relative overflow-hidden rounded-[2.5rem] border border-brand-500/25 bg-gradient-to-br from-brand-600/20 via-pine to-night px-6 py-16 text-center sm:px-12 lg:py-20">
          <div className="pointer-events-none absolute -right-24 -top-24 h-[380px] w-[380px] rounded-full bg-brand-500/20 blur-[110px]" aria-hidden="true" />
          <div className="relative">
            <h2 className="mx-auto max-w-2xl font-display text-4xl font-semibold tracking-tighter text-paper sm:text-5xl" data-testid="cta-heading">
              Ready to <span className="bg-gradient-to-r from-brand-300 to-brand-500 bg-clip-text text-transparent">Get Started?</span>
            </h2>
            <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-mist sm:text-lg">
              Access Rupora and start your verified fund exchange process.
            </p>
            <a
              href="/login"
              data-testid="cta-get-started-button"
              className="group mt-9 inline-flex items-center justify-center gap-2.5 rounded-full bg-gradient-to-r from-brand-500 to-brand-600 px-10 py-4 text-base font-semibold text-white shadow-xl shadow-brand-500/30 transition-all duration-300 hover:shadow-2xl hover:shadow-brand-500/40 hover:brightness-110"
            >
              Get Started
              <ArrowRight size={18} weight="bold" className="transition-transform duration-300 group-hover:translate-x-0.5" />
            </a>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
